import { cryptoInstance } from '@/public/fetch/index';
import { meetingApi2 } from '@/public/utils/basePath';
const baseURL = meetingApi2;
/**
 * @params
 * userId
 * @query
 * isComing 是否即将召开 boolean
 * isMine 是否是已报名 boolean
 * isOperation 会议类型0：学习班，1：训练营，2：omo，3： 线上共学营
 * pageSize 默认 10
 * pageNo
 */
export const getMeetingList = ({ params, query }) => {
    return cryptoInstance.get(`/v5/meeting/list/${params.userId}`, {
        baseURL: meetingApi2,
        params: query
    });
};
/**
 * @params
 * userId
 * @query
 * isComing 是否即将召开 boolean
 * isOperation 会议类型0：学习班，1：训练营，2：omo，3： 线上共学营
 */
export const getTypeList = ({ params, query }) => {
    return cryptoInstance.get(`/v5/meeting/tab/list/${params.userId}`, {
        baseURL: meetingApi2,
        params: query
    });
};
/**
 * @params
 * userId
 * meetingId
 */
export const getMeetingDetail = (params) => {
    return cryptoInstance.get(`/v5/meeting/detail/${params.meetingId}/${params.userId}`, {
        baseURL: meetingApi2
    });
};
/**
 * @params
 * userId
 */
export const getExerciseGuide = (params, query) => {
    return cryptoInstance.get(`/v5/exercise/lesson/navigation/${params.userId}`, {
        baseURL: meetingApi2,
        params: query
    });
};
/**
 * @params
 * userId
 * @query
 * depId
 * applePayId
 * depId
 */
export const createExerciseOrder = (params, query, config) => {
    let con = Object.assign({}, { params: query }, config);
    return cryptoInstance.post(`${meetingApi2}/v5/exercise/order/create/${params.userId}`, {}, con);
};
/**
 * @params
 * orderId
 */
export const getExerciseOrderInfo = (params, config) => {
    let con = Object.assign({}, { baseURL }, config);
    return cryptoInstance.get(`/v5/exercise/order/get_order/${params.orderId}`, con);
};
/**
 * @params
 * meetingId
 * userId
 */
export const createMeetingOrder = (params, query, config) => {
    let con = Object.assign({}, { baseURL, params: query }, config);
    return cryptoInstance.post(`${meetingApi2}/v5/meeting/order/create/${params.meetingId}/${params.userId}`, {}, con);
};
/**
 * @params
 * module
 * userId
 * orderId
 */
export const getMeetOrderInfo = (params, config) => {
    return cryptoInstance.get(`/${params.module}/order/get/${params.userId}/${params.orderId}`, {
        baseURL: meetingApi2,
        ...config
    });
};
/**
 * @params
 * orderIds
 */
export const cancelOrder = (query, config) => {
    let con = Object.assign({}, { isFormData: true }, config);
    return cryptoInstance.post(`${meetingApi2}/meeting/order/cancel`, query, con);
};
export const applyMeeting = (query) => {
    return cryptoInstance.get(`v5/meeting/operation_apply`, {
        baseURL: meetingApi2,
        params: query
    });
};
// 获取用户权益
export const getUserExpireTime = (params) => {
    return cryptoInstance.get(`/v5/exercise/order/getUserExpireTime/${params.userId}`, {
        baseURL: meetingApi2
    });
};
// 练习是否免费
export const meetingIsFree = (query) => {
    return cryptoInstance.get(`/v5/meeting/isFree`, {
        params: { ...query },
        baseURL
    });
};
// 更新0元订单状态
export const updateOrder = (query) => {
    return cryptoInstance.get(`/v5/meeting/order/updateOrder`, {
        params: { ...query },
        baseURL
    });
};
// 创建会员免费订单
export const createFreeOrder = (params) => {
    return cryptoInstance.post(`/v5/meeting/order/freeCreate/${params.meetingId}/${params.userId}`, {}, {
        baseURL
    });
};
// 实操回放
export const operationVideos = (query) => {
    return cryptoInstance.get(`/v5/meeting/operationVideos/${query.meetingId}/${query.userId}`, {
        params: { ...query },
        baseURL
    });
};
// 共学营tab下是否有数据
export const getTabFlag = params => {
    return cryptoInstance.get(`/v5/meeting/tabFlag/${params.userId}`, {
        baseURL: meetingApi2
    });
};
// 获取班期课，omo 共学营 详情
export const getMeetingInfo = (album, meeting, userId, params) => {
    return cryptoInstance.get(`/v8/meeting/detail/${album}/${meeting}/${userId}`, {
        baseURL: meetingApi2,
        params: params || {}
    });
};
